import { render, staticRenderFns } from "./hotelInfoCom.vue?vue&type=template&id=69e8363a&scoped=true"
import script from "./hotelInfoCom.vue?vue&type=script&lang=js"
export * from "./hotelInfoCom.vue?vue&type=script&lang=js"
import style0 from "./hotelInfoCom.vue?vue&type=style&index=0&id=69e8363a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e8363a",
  null
  
)

export default component.exports